export const sanitize = (str: string) => str.split(' ').join('').toLowerCase();

export const fuzzySearch = (needle: string, haystack: (string | undefined)[]) => {
    return haystack.find((hay) => hay !== undefined && sanitize(hay).includes(needle));
};
